(function() {
  const slider = document.querySelector('.hero-slider');
  if (!slider) return;

  const slides = slider.querySelectorAll('.slide');
  const dots = slider.querySelectorAll('.slider-dot');
  const prevBtn = slider.querySelector('.slider-nav.prev');
  const nextBtn = slider.querySelector('.slider-nav.next');
  let currentSlide = 0;
  let autoplayInterval;
  let isTransitioning = false;

  // Performance: Control video playback
  function manageVideos(index) {
    slides.forEach((slide, i) => {
      const videos = slide.querySelectorAll('video');
      videos.forEach(video => {
        if (i === index) {
          video.play().catch(() => {}); // Play active slide video
        } else {
          video.pause(); // Pause inactive videos
          if (!video.hasAttribute('data-loaded')) {
            video.removeAttribute('src'); // Remove src to save bandwidth
          }
        }
      });
    });
  }

  // Preload next slide assets
  function preloadNextSlide(index) {
    const nextIndex = (index + 1) % slides.length;
    const nextSlide = slides[nextIndex];

    // Lazy load next slide images
    const images = nextSlide.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
      if (img.loading === 'lazy') {
        img.loading = 'eager';
      }
    });

    // Preload next video
    const videos = nextSlide.querySelectorAll('video[preload="none"]');
    videos.forEach(video => {
      video.preload = 'metadata';
    });
  }

  function showSlide(index) {
    if (isTransitioning) return;
    isTransitioning = true;

    // Smooth transform animation
    const container = slider.querySelector('.slider-container');
    container.style.transform = `translateX(-${index * 100}%)`;

    slides.forEach(slide => slide.classList.remove('active'));
    dots.forEach(dot => dot.classList.remove('active'));

    slides[index].classList.add('active');
    if (dots[index]) dots[index].classList.add('active');

    currentSlide = index;

    // Performance optimizations
    manageVideos(index);
    preloadNextSlide(index);

    setTimeout(() => { isTransitioning = false; }, 600);
  }

  function nextSlide() {
    let next = (currentSlide + 1) % slides.length;
    showSlide(next);
  }

  function prevSlide() {
    let prev = (currentSlide - 1 + slides.length) % slides.length;
    showSlide(prev);
  }

  // Arrow navigation
  if (prevBtn) prevBtn.addEventListener('click', () => {
    prevSlide();
    if (slider.dataset.autoplay === 'true') {
      stopAutoplay();
      startAutoplay();
    }
  });
  if (nextBtn) nextBtn.addEventListener('click', () => {
    nextSlide();
    if (slider.dataset.autoplay === 'true') {
      stopAutoplay();
      startAutoplay();
    }
  });

  // Dot navigation
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      showSlide(index);
      if (slider.dataset.autoplay === 'true') {
        stopAutoplay();
        startAutoplay();
      }
    });
  });

  // Autoplay
  if (slider.dataset.autoplay === 'true') {
    function startAutoplay() {
      const speed = parseInt(slider.dataset.autoplaySpeed) || 5;
      autoplayInterval = setInterval(nextSlide, speed * 1000);
    }

    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }

    startAutoplay();

    // Pause on hover
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    // Pause when tab not visible (performance)
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
        manageVideos(-1); // Pause all videos
      } else {
        startAutoplay();
        manageVideos(currentSlide);
      }
    });
  }

  // Touch/Swipe support for mobile and Mouse drag for desktop
  let startX = 0;
  let endX = 0;
  let startY = 0;
  let endY = 0;
  let isDragging = false;

  // Touch events (mobile)
  slider.addEventListener('touchstart', (e) => {
    startX = e.changedTouches[0].screenX;
    startY = e.changedTouches[0].screenY;
    isDragging = true;
  }, { passive: true });

  slider.addEventListener('touchend', (e) => {
    endX = e.changedTouches[0].screenX;
    endY = e.changedTouches[0].screenY;
    if (isDragging) {
      handleSwipe();
      isDragging = false;
    }
  }, { passive: true });

  // Mouse events (desktop)
  let hasDragged = false;

  slider.addEventListener('mousedown', (e) => {
    startX = e.clientX;
    startY = e.clientY;
    isDragging = true;
    hasDragged = false;
    slider.style.cursor = 'grabbing';
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    const moveDistance = Math.abs(e.clientX - startX);
    if (moveDistance > 5) {
      hasDragged = true;
      e.preventDefault();
    }
  });

  slider.addEventListener('mouseup', (e) => {
    if (!isDragging) return;
    endX = e.clientX;
    endY = e.clientY;
    handleSwipe();
    isDragging = false;
    slider.style.cursor = 'grab';

    // Prevent click if user dragged
    if (hasDragged) {
      setTimeout(() => { hasDragged = false; }, 100);
    }
  });

  slider.addEventListener('mouseleave', () => {
    if (isDragging) {
      isDragging = false;
      slider.style.cursor = 'grab';
    }
  });

  // Prevent click on links/buttons if dragging
  slider.addEventListener('click', (e) => {
    if (hasDragged) {
      e.preventDefault();
      e.stopPropagation();
      hasDragged = false;
    }
  }, true);

  function handleSwipe() {
    const swipeThreshold = 50; // Minimum distance for swipe
    const horizontalDiff = startX - endX;
    const verticalDiff = Math.abs(startY - endY);

    // Only trigger if horizontal swipe is greater than vertical (prevent conflicts with scrolling)
    if (Math.abs(horizontalDiff) > swipeThreshold && Math.abs(horizontalDiff) > verticalDiff) {
      if (horizontalDiff > 0) {
        // Swiped/dragged left - go to next slide
        nextSlide();
      } else {
        // Swiped/dragged right - go to previous slide
        prevSlide();
      }

      // Reset autoplay after manual interaction
      if (slider.dataset.autoplay === 'true') {
        stopAutoplay();
        startAutoplay();
      }
    }
  }

  // Keyboard navigation (only when slider in viewport)
  let isInViewport = false;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      isInViewport = entry.isIntersecting;
    });
  }, { threshold: 0.5 });
  observer.observe(slider);

  document.addEventListener('keydown', (e) => {
    if (!isInViewport) return;
    if (e.key === 'ArrowLeft') prevSlide();
    if (e.key === 'ArrowRight') nextSlide();
  });

  // Initialize: Manage first slide
  manageVideos(0);
  preloadNextSlide(0);
})();
